import React from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';
import StudentHeader from './Student/new';
import TutorHeader from './Tutor/new';
import GuestHeader from './Guest/new';
import * as AuthActions from '../../../../actions/auth';
import { withTranslation } from 'next-i18next';
import { hasRole } from '@lb-classroom/feature-auth';

interface User {
  id?: string | number;
  profile_type: string | string[];
  first_name?: string;
  thumb_avatar_url?: string;
  js_time_zone?: string;
}

interface AuthActionsType {
  logout: () => void;
}

interface RootState {
  [key: string]: unknown;
}

interface HeaderProps {
  t: (key: string, options?: Record<string, unknown>) => string;
  user?: User;
  currentLocale?: string; // deprecated - kept for backwards compatibility with layout.tsx
  authActions?: AuthActionsType;
}

function mapStateToProps(_state: RootState) {
  return {};
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    authActions: bindActionCreators(
      AuthActions as unknown as Record<string, (...args: unknown[]) => unknown>,
      dispatch,
    ) as unknown as AuthActionsType,
  };
}

const Header: React.FC<HeaderProps> = (props) => {
  const { user } = props;
  const router = useRouter();

  if (user) {
    const isTutor = hasRole(user.profile_type, 'Tutor');
    const isStudent = hasRole(user.profile_type, 'Student');
    const isOnTutorPage = router.pathname.startsWith('/t/');
    const isOnStudentPage = router.pathname.startsWith('/s/');

    // Route-aware header selection for dual-role users
    if (isOnTutorPage && isTutor) {
      return <TutorHeader user={user} />;
    } else if (isOnStudentPage && isStudent) {
      return <StudentHeader user={user} />;
    } else if (isTutor) {
      // Fallback for non-role-specific pages (e.g., /messages, /tutors)
      return <TutorHeader user={user} />;
    } else if (isStudent) {
      return <StudentHeader user={user} />;
    } else {
      return <GuestHeader />;
    }
  } else {
    return <GuestHeader />;
  }
};

const wrappedHeader = withTranslation('common')(Header);

export default connect(mapStateToProps, mapDispatchToProps)(wrappedHeader);
